<style>
  .assumptions_item_container {
    align-items: baseline;
    font-size: 16px;
    flex-direction: column;

    > div:nth-child(1) {
      display: inline-block;
    }

    > div:nth-child(2) {
      margin-left: 20px;
      display: inline-block;
      margin-bottom: 10px;
      width: 80px;
    }

    > div:nth-child(3) {
      width: 100%;
      display: flex;
      gap: 10px;
      justify-content: space-between;
    }

    @media (min-width: 800px) {
      display: flex;
      flex-direction: row;
      gap: 20px;

      > div:nth-child(1) {
        width: 150px;
        font-size: 14px;
      }
      > div:nth-child(2) {
        margin-bottom: 0;
      }
      > div:nth-child(3) {
        flex: 1 1 0;
        display: flex;
      }
    }
    &.assumptions_item_container__header {
      > div:nth-child(1), > div:nth-child(2) {
        display: none;
      }
      margin-bottom: 10px;
      @media (min-width: 800px) {
        display: flex;
        font-size: 14px;
        color: #727171;
      }
   }
  }
</style>

<template>
  <div class="dialog_resource__assumptions">
    <div
      v-if="name"
      style="font-weight: bold; color: #000;">
      {{ name }}
    </div>

    <div
      style="border-top: 1px solid #ddd; padding: 10px 0;">
      <div style="display: flex;">
        <v-select
          v-if="formulasAvailable.length > 1"
          :items="formulasAvailable"
          label="Income Formula"
          v-model="flow.formula"
          item-text="name"
          item-value="id"
          return-object
          @change="onFormulaChange"
          outlined
          dense
          background-color="white"
        ></v-select>
      </div>

      <div>
        <div class="assumptions_item_container assumptions_item_container__header">

          <div>
            {{ translate('ui_dialog_assumptions_name') }}
          </div>

          <div v-if="!hideUnits">
            {{ translate('ui_dialog_assumptions_units') }}
          </div>

          <div>
            <span>
              {{ translate('ui_dialog_assumptions_fcst') }}
            </span>
            <a
              @click="showTooltip = !showTooltip"
              style="text-decoration: underline; float: right;"
            >
              {{ translate('ui_dialog_view_hint_btn') }}
            </a>
          </div>

        </div>

        <div
          v-if="flow.fcst.length && flow.formula.variables.length"
        >
          <template v-for="(variable, i) in flow.fcst">
            <div
              v-show="!flow.formula.variables[i].reference"
              class="assumptions_item_container"
              :key="i"
            >
              <div style="color: #000;">
                <span v-if="isEditingFormula">
                  <v-text-field
                    v-model="flow.formula.variables[i].name"
                    required
                    outlined
                    dense
                    background-color="white"
                    hide-details
                  ></v-text-field>
                  <v-checkbox v-model="variable.isCurrency" dense label="Is currency?"></v-checkbox>
                </span>
                <span v-if="!isEditingFormula">
                 {{ translate(flow.formula.variables[i].name) }}
                </span>
              </div>

              <div
                v-if="!hideUnits"
                style="color: #000;"
              >
                <div
                  v-if="flow.formula.variables[i].isCurrency
                  && currencies.length === 1"
                  style="text-align: right;"
                >
                  {{ flow.fcst[i].scenarios[0].units.name }}
                </div>

                <v-select
                  v-if="flow.formula.variables[i].isCurrency
                  && currencies.length > 1"
                  :items="currencies"
                  v-model="flow.fcst[i].scenarios[0].units"
                  outlined
                  dense
                  background-color="white"
                  hide-details
                ></v-select>

                <v-text-field
                  v-if="!flow.formula.variables[i].isCurrency"
                  v-model="flow.fcst[i].scenarios[0].units"
                  required
                  outlined
                  dense
                  background-color="white"
                  :placeholder="translate('ui_dialog_assumptions_units')"
                  hide-details
                ></v-text-field>
              </div>

              <DialogResourceAddFlowAssumptions
                :assumptions="assumptions"
                :index="i"
                :sampleDataEnabled="!hideUnits"
                @updateFlowAssumptions="updateFlowAssumptions"
              />
            </div>
          </template>
        </div>

        <div
          v-if="shouldShowAutoDrawDownOtherAssumptions"
          style="display: flex; font-size: 16px;"
        >
          <div style="color: #000; width: 150px;">
            {{ this.translate('input_resource_options_commitmentpercent') }}
          </div>
          <div style="width: 100px; color: #000; text-align: right;">
            {{ this.translate('ui_section_financing__rate_units') }}
          </div>
          <v-text-field
            data-qa="dialog_resource__assumptions_input"
            v-model="dialogConfig.resource.otherAssumptions.commitment.value"
            required
            style="align-items: center; padding-left: 20px;"
            outlined
            dense
            background-color="white"
          ></v-text-field>
        </div>
      </div>
    </div>

    <DialogResourceAddHintAssumptions
      :showTooltip="showTooltip"
      @closeDialogHintAssumptions="closeDialogHintAssumptions"
    />

  </div>
</template>

<script>
import DialogResourceAddFlowAssumptions from './DialogResourceAddFlowAssumptions.vue';
import DialogResourceAddHintAssumptions from './DialogResourceAddHintAssumptions.vue';

// mixins
import Mixin from '../../../mixins/mixin';

export default {
  components: {
    DialogResourceAddFlowAssumptions,
    DialogResourceAddHintAssumptions,
  },
  props: {
    name: String,
    flow: Object,
    flowIndex: Number,
    dialogConfig: Object,
    formulasAvailable: Array,
    dialogUnits: Array,
    updateAssumptions: Function,
    dialogFlows: Array,
    dialogFormula: Object,
    hideUnits: Boolean,
    isEditingFormula: Boolean,
  },
  mixins: [Mixin],
  data() {
    return {
      // flow: this.dialogConfig.resource.flows[this.flowIndex],
      showTooltip: false,
    };
  },
  computed: {
    shouldShowAutoDrawDownOtherAssumptions() {
      return this.flow.id === 'incCash' && !this.flow.formula.variables.length && (this.dialogConfig.resource.coreResource.rel === 'loan' || this.dialogConfig.resource.coreResource.rel === 'equity');
    },
    currencies() {
      // get currencies
      const sectionMacro = this.$store.state.activeTemplate.data.sections.find((section) => section.id === 'section_environment');
      const sectionCurrencies = sectionMacro.sections[0];
      return sectionCurrencies.sectionResources
        .map((sr) => sr.coreResource.name);
    },
    assumptions() {
      return this.flow.fcst.map((fcst) => fcst.scenarios[0].data);
    },
  },
  methods: {
    closeDialogHintAssumptions() {
      this.showTooltip = false;
    },
    updateFlowAssumptions(assumptionIndex, value) {
      this.updateAssumptions(this.flowIndex, assumptionIndex, value);
    },
  },
};

</script>
